import { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

const PARAMS_WHITELIST = [
  'verificationEmailCode',
  'redirectTo',
  'code',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'type',
];

function useCleanAndValidateQueryParams() {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const cleanedParams: Record<string, string> = {};

    // Process only whitelisted parameters
    PARAMS_WHITELIST.forEach((param) => {
      if (searchParams.has(param)) {
        cleanedParams[param] = searchParams.get(param) ?? '';
      }
    });

    // Construct the cleaned query string
    const cleanedSearch = new URLSearchParams(cleanedParams).toString();

    // Redirect if the query string differs from the cleaned version
    if (cleanedSearch !== location.search.substring(1)) {
      history.replace(`${location.pathname}?${cleanedSearch}`);
    }
  }, [location, history]);
}

export default useCleanAndValidateQueryParams;
